import {
  borderWidths,
  colors,
  media,
  NewTypography as Typography,
  opacity,
  radius,
  spacing,
} from '@lamimed/pantheon';
import Link from 'next/link';
import { rgba } from 'polished';
import styled, { css } from 'styled-components';

type OutlineProps = {
  active?: boolean;
};

export const Outline = styled.hr<OutlineProps>`
  ${({ active = false }) => css`
    padding: inherit;
    width: 100%;
    position: absolute;
    bottom: 0;
    border: ${borderWidths.thin} solid
      ${active ? colors.dark : rgba(colors.dark, opacity.hard)};
  `};
`;

export const tabbarHeight = '2.6rem';

export const Item = styled(Link)`
  position: relative;
  height: ${tabbarHeight};
  display: flex;
  flex-grow: 1;
  flex-direction: row;
  padding: 0 ${spacing.small};
  align-items: center;
  justify-content: center;

  ${media.greaterThan('tablet')`
    flex-grow: initial;
    padding: 0 ${spacing.medium};
  `};
`;

export const Container = styled.div`
  display: flex;
  flex-direction: row;
  margin-top: ${spacing.medium};

  ${Item}:first-child {
    ${Outline} {
      border-radius: ${radius.small} 0 0 ${radius.small};
    }
  }

  ${Item}:last-child {
    ${Outline} {
      border-radius: 0 ${radius.small} ${radius.small} 0;
    }
  }
`;

export const SmallTypography = styled(Typography)`
  && {
    font-size: 1rem;
  }
`;

export const Icon = styled.div`
  margin-right: 0.6rem;
`;

export const NotificationContainer = styled.div`
  position: absolute;
  top: 0;
  right: 0;
  width: 1.4rem;
  height: 1.4rem;
  background-color: ${colors.dark};
  border-radius: ${radius.small};
  display: flex;
  align-items: center;
  justify-content: center;
`;
